import React from "react"
import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {getDynamicInterestRate} from "../../resources/interestRate"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {formatPercent} from "../../utilities/numbers"
import {InterestItem, PrimeLoanRateItem} from "./InterestItem"

const RATE_FORMAT = "111.[11]%"

const InterestPending = () => (
	<>
		<InterestItem icon={"Percentage Increase"} />
		<InterestItem icon={"Percentage Decrease"} />
	</>
)

export function InterestOverviewForUnitUser() {
	const accessToken = useAccessToken()
	const interestRateResult = useAsyncResult(() => getDynamicInterestRate(accessToken))

	return (
		<div className={"interest-rate-overview"}>
			<AsyncResultComponent asyncResult={interestRateResult} pendingComponent={<InterestPending />}>
				{({value: interestRate}) => {
					const {
						data: {
							attributes: {upperBoundRate, lowerBoundRate, effectiveFrom},
						},
					} = interestRate
					const upperTargetRange = upperBoundRate / 100
					const lowerTargetRange = lowerBoundRate / 100
					const additionalInfoString = `Effective from ${effectiveFrom}`
					return (
						<>
							<InterestItem
								icon={"Percentage Increase"}
								title={"Federal Funds Upper Target Range"}
								value={formatPercent(upperTargetRange, RATE_FORMAT)}
								additionalInfo={additionalInfoString}
							/>
							<InterestItem
								icon={"Percentage Decrease"}
								title={"Federal Funds Lower Target Range"}
								value={formatPercent(lowerTargetRange, RATE_FORMAT)}
								additionalInfo={additionalInfoString}
							/>
							<PrimeLoanRateItem />
						</>
					)
				}}
			</AsyncResultComponent>
		</div>
	)
}

export const InterestForUnitUser = () => (
	<div className="card">
		<div className="interest-rate-container">
			<h3 className="light">Interest</h3>
			<div className="columns is-align-items-center">
				<div className="column is-8 is-align-self-flex-end">
					<InterestOverviewForUnitUser />
				</div>
			</div>
		</div>
	</div>
)
